import { Tooltip as MUITooltip, TooltipProps } from '@mui/material';

export { type TooltipProps } from '@mui/material';

export function Tooltip(props: TooltipProps) {
  return <MUITooltip {...props} />;
}
